import { render, staticRenderFns } from "./Campus.vue?vue&type=template&id=d6e5b1d4"
import script from "./Campus.vue?vue&type=script&lang=ts"
export * from "./Campus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports